import { styled } from '@mui/material';

export const AutocompleteGroupHeader = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  position: 'sticky',
  top: theme.spacing(-1),
  padding: theme.spacing(1),
  fontWeight: 600,
}));

export const AutocompleteGroupItems = styled('ul')({
  padding: 0,
});
